<template>
  <div class="home-box" :class="$store.state.home.scrollState<=0 ? $store.state.home.navIndex===2 ? '' : 'home-box1' : ''">
    <header>
        <div class="home-box-head">
            <div class="home-box-head-left">
                <div class="home-box-head-img p-pointer" @click="$router.replace({path:'/'})" style="position:relative">
                    <img  src="@p/assets/images/icon/logo-footer.png" alt="logo">
                    <span class="version">BETA {{releaseNumber}}</span>
                </div>
                <div class="home-box-head-course">
                    <!-- <course-nav></course-nav> -->
                    <home-course></home-course>
                </div>
                <div class="home-box-head-search">
                    <home-search @searchChange="searchChang" :searchlists="searchlist"></home-search>
                </div>
            </div>
            <div class="home-box-head-right">
                <div class="home-box-head-right-a" v-if="$store.state.home.userInfo.is_admin">
                    <el-link @click="setAdminCookie" target="_blank">後臺管理</el-link>
                </div>
                <div class="home-box-head-right-language">
                    <el-dropdown @command="langHandleCommand">
                        <span class="el-dropdown-link p-pointer">
                            {{language[lang]}}<i class="el-icon-arrow-down el-icon--right"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item command="zh">中文</el-dropdown-item>
                            <!-- <el-dropdown-item command="en">English</el-dropdown-item>
                            <el-dropdown-item command="es">Español</el-dropdown-item> -->
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>
                <div class="home-box-head-right-remind p-pointer" @click="$router.push({path:'/home/message',query:{title:'消息'}})">
                    <span>
                        <img src="@p/assets/images/icon/message.png">
                    </span>
                    <div>消息</div>
                </div>
                <div class="home-box-head-right-user">
                    <el-dropdown @command="handleCommand">
                        <span class="el-dropdown-link p-pointer">
                            <el-avatar class="" :size="32" :src="require('@p/assets/images/user.png')"></el-avatar>
                            <div class="home-box-head-right-user-username">{{$store.state.home.userInfo.staff.username}}</div>
                            <i class="el-icon-caret-bottom home-box-head-right-user-username"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item command="/personal">個人中心</el-dropdown-item>
                            <el-dropdown-item command="userQuit" divided>退出登錄</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>
            </div>
        </div>
    </header>
    <home-banner v-if="$route.name === 'homePage' && $store.state.home.navIndex!==2"></home-banner>
    <section :style="$route.name === 'homePage' && 'padding-top:0;'">
        <div class="home-box-con" :class="{'home-box-con1' : $route.name === 'study'}">
            <el-breadcrumb separator-class="el-icon-arrow-right" style="margin-top:16px;" v-if="breadcrumb.length && $route.name != 'homePage' && $route.name != 'personal'">
                <el-breadcrumb-item :to="{ path: '/' , }" replace v-if="breadcrumb[0]['path']!='/personal'">首頁</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: item.path,query:item.query }" replace v-for="(item,index) in breadcrumb" :key="index">
                    {{item.query ? breadcrumbDecodeURIComponent(item.query.title) : ''}}
                </el-breadcrumb-item>
            </el-breadcrumb>
            <slot></slot>
        </div>
    </section>
    <home-footer></home-footer>
    <fixed-client></fixed-client>
  </div>
</template>

<script>
import homeBanner from './home-banner'
import fixedClient from './fixed-client'
import homeSearch from './home-search'
import homeFooter from './home-footer'
import homeCourse from './home-course'
import storage from '@/utils/storage'
import { configUrl } from '@/utils/config'
import config from '@/config'
export default {
    data(){
        return {
            language:{
                zh:'中文',
                en:'English',
                es:'Español',
            },
            lang:'zh',
            searchlist:[],                  //搜索数据列表
            releaseNumber: config.releaseNumber
        }
    },
    created(){
        this.getStaffInfo();
        // this.lang=localStorage.getItem('lang') || 'zh';
        if(this.$route.name != 'homePage'){
            this.$store.commit('setScrollState',1);
        }
    },
    watch:{
        $route(to,from){
            if(to.name!='homePage'){
                this.$store.commit('setScrollState',1);
            }else{
                this.$store.commit('setNavIndex',1);
                this.$store.commit('setScrollState',0);
            }
        }
    },
    computed:{
        breadcrumb(){
            return this.$store.state.home.breadcrumb;
        }
    },
    mounted: function () {
        // document.addEventListener('scroll', this.handleScroll, true);  // 监听（绑定）滚动事件
    },
    methods:{
        breadcrumbDecodeURIComponent (v) {
            try {
                return decodeURIComponent(v)
            } catch (error) {
                return v
            }
            return v
        },
        //搜索
        async searchChang(searchStr){
            this.searchStr=[];
            await this.$http.home.getCourseSearch({searchStr,page:1,take:10}).then(v=>{
                if(v.status === 200){
                    this.searchlist=v.data.data.data;
                }
            }).catch(v=>{})
        },
        //获得信息
        async getStaffInfo(searchStr){
            //用户
            await this.$http.personal.getStaffInfo().then(v=>{
                if(v.status === 200 && v.data.status_code === 200){
                    this.$store.commit('getStaffInfo',v.data.data)
                }
            }).catch(v=>{})
            //全部课程
            await this.$http.home.getAllCourseClass().then(v=>{
                if(v.status === 200){
                    this.$store.commit('setCourseData',v.data.data);
                }
            }).catch(er=>{})
        },
        // 用户
        handleCommand(command,e) {
            if(command === 'userQuit'){
                storage.localRemove('username');
                // storage.localRemove('password');
                storage.localRemove('token');
                this.$router.replace('/login');
            }else{
                this.$router.replace({path:command,query:{title:e.$el.innerText.substring(0,4)}});
            }
        },
        // 语言
        langHandleCommand(lang){
            this.$i18n.locale = lang;
            this.lang=lang;
            localStorage.setItem('lang',lang)
        },
        // 滚动
        handleScroll(){
            let clientHeight = document.documentElement.clientHeight || document.body.clientHeight;  
            let scrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop; // 头部的距离
            if(this.$router.history.current.name === 'homePage'){
                if(scrollTop>120 && this.$store.state.home.scrollState===0){
                    this.$store.commit('setScrollState',1);
                }else if(scrollTop<120 && this.$store.state.home.scrollState===1){
                    this.$store.commit('setScrollState',0);
                }
            }
        },
        // 设置管理页面cookie
        setAdminCookie () {
            let token = storage.localGet('token');
            document.cookie = `LMS_TICKET=${token};domain=${config.domain}`
            window.open(config.admin)
        }
    },
    components:{
        fixedClient,homeBanner,homeSearch,homeFooter,homeCourse
    },
}
</script>

<style lang="less" scoped>
.el-avatar{
    background: 0;
}
.version{
    color: #fff;
    font-size: 12px;
    width: 70px;
    top: 45px;
    position: absolute;
}
.logout{
    background: url(../../assets/images/icon/logout.png) no-repeat
}
@import "./index.less"; 
</style>